import { Form, Modal } from 'antd';
import { FormInstance } from 'antd/es/form/Form';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment/moment';
import React, { useRef } from 'react';

import RemoteSelect from '@components/fw/RemoteSelect';
import { stationWithParagraphsTemplate } from '@components/routed/OptionsPage/TariffForm/OptionsStationSelectorBtn';
import { UserOperationInfoFormProps } from '@components/routed/UserOperationInfoPage/ui/form/types/form-props';

import dictService from '@stores/dictStore/dictStore.service';
import { userOperationInfoStore } from '@stores/userOperationInfoStore';

export const UserOperationInfoForm = observer(({ onChange }: UserOperationInfoFormProps) => {
  const showForm = computed(() => userOperationInfoStore.showForm).get();

  const formRef = useRef<FormInstance>(null);

  return (
    <Modal
      destroyOnClose={true}
      title={'Ввод информации'}
      open={showForm}
      onOk={() => formRef.current.submit()}
      onCancel={() => userOperationInfoStore.setShowForm(false)}>
      <Form
        ref={formRef}
        onFinish={(e) => {
          userOperationInfoStore.updateInfo(e.loadStationCode, e.destStationCode).then(() => {
            userOperationInfoStore.setShowForm(false);
            onChange();
          });
        }}>
        <Form.Item name={'loadStationCode'}>
          <RemoteSelect
            float={true}
            primitiveResult={true}
            itemTemplate={stationWithParagraphsTemplate}
            placeholder={'Станция погрузки'}
            size={'middle'}
            valueExpr={'stationCode'}
            aValueExpr={moment().toISOString()}
            displayExpr={'fullName'}
            dataSource={dictService.stationWithParagraphDict}
          />
        </Form.Item>
        <Form.Item name={'destStationCode'}>
          <RemoteSelect
            float={true}
            primitiveResult={true}
            itemTemplate={stationWithParagraphsTemplate}
            placeholder={'Станция назначения'}
            size={'middle'}
            valueExpr={'stationCode'}
            aValueExpr={moment().toISOString()}
            displayExpr={'fullName'}
            dataSource={dictService.stationWithParagraphDict}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
});
